/********** DATATABLE **********/

export const GET_ADDON_DT = 'GET_ADDON_DT'
export const GET_ADDON_DT_OK = 'GET_ADDON_DT_OK'
export const GET_ADDON_DT_ERR = 'GET_ADDON_DT_ERR'
export const DO_ADDON_DT_CLEANUP = 'DO_ADDON_DT_CLEANUP'

/********** DATATABLE FILTERS **********/

export const APPLY_ADDON_DT_FILTERS = "APPLY_ADDON_DT_FILTERS"
export const PATCH_ADDON_DT_FILTERS = "PATCH_ADDON_DT_FILTERS"
export const CLEAR_ADDON_DT_FILTERS = "CLEAR_ADDON_DT_FILTERS"
export const UNSET_ADDON_DT_FILTERS = "UNSET_ADDON_DT_FILTERS"
export const DO_ADDON_DT_FILTERS_CLEANUP = "DO_ADDON_DT_FILTERS_CLEANUP"